<template>
  <el-tag size="small" :type="type"> {{ modelValue }}% </el-tag>
</template>
<script lang="ts">
import { defineComponent, computed } from 'vue'

const QUALITIES: Record<number, string> = {
  30: 'danger',
  50: 'warning',
  100: 'success',
  0: 'primary'
}

export default defineComponent({
  name: 'PercentLabel',
  props: {
    modelValue: {
      type: Number,
      required: true
    }
  },
  setup(props, context) {
    const type = computed(() => {
      if (props.modelValue < 30) {
        return QUALITIES[30]
      } else if (props.modelValue < 50) {
        return QUALITIES[50]
      } else if (props.modelValue <= 100) {
        return QUALITIES[100]
      } else {
        return QUALITIES[0]
      }
    })
    return { type }
  }
})
</script>
<style lang="scss" scoped>
.el-tag {
  border: none !important;
}
</style>
